import rfdc from 'rfdc';

const instance = rfdc();

export function clone<T>(data: T) {
  return instance(data);
}
